import * as React from "react"
import { navigate } from "@gatsbyjs/reach-router"
import { usePersistentState } from "@modules/toolkit/hooks/usePersistentState"

export const useAnnouncement = (name: string) => {
  const [isOpened, setIsOpened] = React.useState(false)
  const [
    lastViewedAnnouncement,
    setLastViewedAnnouncement,
  ] = usePersistentState<string>("gatsbyjs:announcement", "")

  const alreadyViewed = lastViewedAnnouncement === name

  const handleOpenAnnouncement = () => {
    if (alreadyViewed) {
      return navigate(`/release-notes`)
    }

    setIsOpened(true)
  }

  const handleCloseModal = () => {
    setLastViewedAnnouncement(name)
    setIsOpened(false)
  }

  return {
    isNewAnnouncement: !alreadyViewed,
    isOpened,
    openAnnouncement: handleOpenAnnouncement,
    closeAnnouncement: handleCloseModal,
  }
}
